module.exports = __webpack_public_path__ + "static/media/5.8b038020.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/5.jpg
// module id = 196
// module chunks = 0